<template>
  <div
    class="
      card
      shadow-sm
      text-dark text-start
      max-card-height
      d-flex
      flex-column
    "
  >
    <div class="card-body p-2">
      <div><MultipleChoice /></div>
    </div>
  </div>
</template>

<script>
import MultipleChoice from "@/components/MultipleChoice.vue";

import EventAPI from "@/helpers/EventAPI";

export default {
  name: "CurrentContainerView",
  components: { MultipleChoice },
  mixins: [EventAPI],
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {},
  mounted() {
    let payload = {
      event_name: "Began"
    };
    this.createContentEntry(payload);
  }
};
</script>

<style scoped>
.max-card-height {
  max-height: 700px;
}
.card-body {
  overflow-y: auto;
}
</style>
